import React from "react";
import { motion } from "framer-motion";

const Breadcrumb = ({ title, bgImage }) => {

  const fade = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  return (
    <>
      <motion.section
        className="breadcrumb"
        style={{ backgroundImage: `url(${bgImage})` }}
        initial="hidden"
        animate="visible"
        variants={fade}
      >
        {/* Overlay */}
        <motion.div
          className="breadcrumb-overlay"
          variants={fade}
        />

        {/* Content */}
        <div className="container breadcrumb-content">
          <motion.h1 variants={fade}>
            {title}
          </motion.h1>
        </div>
      </motion.section>
    </>
  );
};

export default Breadcrumb;